// extracted by mini-css-extract-plugin
export var modalBox = "H_wR";
export var backdrop = "H_wS";